import { Badge } from "primereact/badge";
import "./Badge.css";

const BadgeFitprenda = (props: any) => {
  return (
    <>
      <Badge
        value={props.value}
        severity={props.variant ? props.variant : "success"}
        className="badge-fitprenda-font"
      ></Badge>
    </>
  );
};

export default BadgeFitprenda;
